import React, { useEffect, useMemo, useState, useCallback, ReactNode } from "react";
import StyledModal from "../../../components/CustomModal";
import { ImageContainer, PreMatchImageWrapper } from "../ReportDetailsBody/style";
import { FooterButtonsContainer, LeftButtons, ModalContent, RightButtons, StepText, TitleContent, TitleWrapper, BackArrow } from "./styles";
import { Skeleton, Form, Select, message } from "antd";
import { StyledButton } from "../../../components/styles";
import { convertUtcToLocal } from "../../../utils/helpers/convertUtcToLocal";
import { useAppDispatch, useAppSelector } from "../../../utils/hooks/redux";
import { Image } from "antd";
import { apiEndpoints } from "../../../utils/constants/apiEndpoints";
import api from "../../../utils/constants/api";
import { ActivationStatus, PaymentStatus, Question, Report } from "../../../types";
import { ApiResponse } from "../../../types/APIResponse";
import { updateLostItemStatus } from "../../../redux/features/board/columnsAsyncThunk";
import { convertIntoBoardTicket, removeTicketById, updateTicketLocally, updateTicketStatusLocally } from "../../../redux/features/board/columnsSlice";
import { linkFoundItemWithLostItemAsyncThunk, createPrematchData, getAllShippingOptions, sendPaymentRequest, updateLostItemCaseManager } from "../../../redux/features/report/reportAsyncThunk";
import Step1 from "./PrematchStep/Step1";
import Step2 from "./PrematchStep/Step2";
import Step3 from "./PrematchStep/Step3";
import DimensionsTable from "./PrematchStep/DimensionsTable";
import { convertToApiFormat } from "../../../utils/helpers/unitConversion";
import { updateFoundItemCaseManager, updateFoundItemStatus } from "../../../redux/features/foundReport/foundReportAsyncThunk";
import { FoundStatuses } from "../../../types/FoundItemTypes";
import { selectUsers } from "../../../redux/features/user/userSlice";
import { unAssignCaseMangerOptionValue } from "../../../utils/constants/filterOption";
import { RequestResults } from "../../../redux/common/RequestStatus";
import { AdminUser } from "../../../redux/features/user/types";
import { ReportType } from "../../../redux/features/board/columnTypes";
import ConfirmationModal from "../../../components/ConfirmationModal";
import { updateItemCaseManager } from "../../../redux/features/foundReport/foundReportSlice";
import { updateCaseManager } from "../../../redux/features/report/reportSlice";
import { selectUserRole } from "../../../redux/features/auth/selectors";
import { checkHasPermission } from "../../../utils/helpers/checkHasPermission";
import { permissions } from "../../../utils/constants/permissions";
import { selectShipFromPort } from "../../../redux/features/ShipFromPort/ShipFromPortSlice";
import { fetchShipFromPorts } from "../../../redux/features/ShipFromPort/ShipFromPortAsyncThunk";
import { LostStatuses } from "../../../types/LostStatuses";
import { toast } from "react-toastify";
import { useFetchReport } from "../../../utils/hooks/useFetchReport";
import dayjs from "dayjs";
import { enableCutOffDate, shipMatchEnabled } from "../../../utils/constants";

interface PrematchModalProps {
  isMarkModalOpen: boolean;
  handleMarkCancel: () => void;
  handleItemClick: (item: any) => void;
  form: any;
  selectedItem: any;
  isFinalMatch?: boolean;
}

const PrematchModal: React.FC<PrematchModalProps> = ({ isMarkModalOpen, handleMarkCancel, form, selectedItem, handleItemClick, isFinalMatch }) => {
  const preMatchedFoundItems = useAppSelector((state) => state.report.preMatchedFoundItems);
  const { report, status, error } = useAppSelector((state) => state.report);

  const [selectedItemDetails, setSelectedItemDetails] = useState<Report | null>(null);
  const [selectedItemDetailsStatus, setSelectedItemDetailsStatus] = useState<"idle" | "loading" | "succeeded" | "failed">("idle");
  const [loading, setLoading] = useState(false);
  const [selectedCaseManager, setSelectedCaseManager] = useState<any>("");
  const [selectedFoundCaseManager, setSelectedCaseFoundManager] = useState<any>("");
  const [updateCaseManger, setUpdateCaseManger] = useState<{ id: string; type: ReportType } | null>(null);
  const dispatch = useAppDispatch();
  const [step, setStep] = useState<number>(1);
  const { caseManagers, status: caseManagerStatus } = useAppSelector(selectUsers);
  const fetchReport = useFetchReport();

  const [step2Form] = Form.useForm();
  const [step3Form] = Form.useForm();

  const [step2Data, setStep2Data] = useState<any>({});
  const { shippingOptions, paymentRequestLoading } = useAppSelector((state) => state.report);
  const userRole = useAppSelector(selectUserRole);
  const isPaymentSucceeded = useMemo(() => report?.payment?.some((payment) => payment.status === PaymentStatus.Succeeded), [report]);
  const isFinalMatchPermission = useMemo(() => checkHasPermission(userRole, permissions.IsFinalMatchStatusEnabled) && !isPaymentSucceeded, [userRole, isPaymentSucceeded]);

  const { data: ShipFromPorts, status: ShipFromPortStatus, loading: ShipFromPortLoading } = useAppSelector(selectShipFromPort);

  const getSelectedItemDetails = async (item: any) => {
    try {
      setSelectedItemDetailsStatus("loading");
      const response: ApiResponse<Report> = await api.get(`${apiEndpoints.found.getFoundItemByItemNumber}?itemNumber=${item?.itemNumber}`);
      setSelectedItemDetails(response.data);
      setSelectedItemDetailsStatus("succeeded");
    } catch (error) {
      setSelectedItemDetailsStatus("failed");
    }
  };

  const caseManagerUsers = useMemo(() => {
    if (caseManagers?.length > 0) {
      const users: { value: string; label: ReactNode; key: string }[] = caseManagers?.map((user) => ({
        value: user?.id,
        label: user?.firstName + " " + user?.lastName,
        key: user?.id
      }));

      if (report?.caseManager?.id) {
        // Add "Unassign User" option at the end
        users.push({
          value: unAssignCaseMangerOptionValue,
          label: <span style={{ color: "red" }}>Unassign User</span>,
          key: unAssignCaseMangerOptionValue
        });
        setSelectedCaseManager(report?.caseManager?.id)
      }

      return users;
    }
    return [];
  }, [caseManagers, report?.caseManager?.id]);

  const foundItemCaseManagerUsers = useMemo(() => {
    if (caseManagers?.length > 0) {
      const users: { value: string; label: ReactNode; key: string }[] = caseManagers?.map((user) => ({
        value: user?.id,
        label: user?.firstName + " " + user?.lastName,
        key: user?.id
      }));

      if (selectedItemDetails?.caseManager?.id) {
        // Add "Unassign User" option at the end
        users.push({
          value: unAssignCaseMangerOptionValue,
          label: <span style={{ color: "red" }}>Unassign User</span>,
          key: unAssignCaseMangerOptionValue
        });
        setSelectedCaseFoundManager(selectedItemDetails?.caseManager?.id)
      }

      return users;
    }
    return [];
  }, [caseManagers, , selectedItemDetails?.caseManager?.id]);


  const confirmUpdateCaseManager = useMemo(() => {
    if (caseManagerUsers && caseManagerUsers?.length > 0 && updateCaseManger?.type === ReportType.Lost && updateCaseManger?.id) {
      const updateCaseMangerId = updateCaseManger?.id;
      const currentCaseManager = caseManagerUsers?.find((user) => user?.value === selectedCaseManager)?.label;
      const newCaseManager = caseManagerUsers?.find((user) => user?.value === updateCaseMangerId)?.label;
      return updateCaseMangerId !== unAssignCaseMangerOptionValue && currentCaseManager ? `Are you sure to unassign ${currentCaseManager} and assign to ${newCaseManager} for this report?` : updateCaseMangerId === unAssignCaseMangerOptionValue && currentCaseManager ? `Are you sure to unassign ${currentCaseManager}?` : updateCaseMangerId && !selectedCaseManager ? `Are you sure to assign ${newCaseManager} for this report?` : "";
    } else if (foundItemCaseManagerUsers && foundItemCaseManagerUsers?.length > 0 && updateCaseManger?.type === ReportType.Found && updateCaseManger?.id) {
      const updateCaseMangerId = updateCaseManger?.id;
      const currentCaseManager = foundItemCaseManagerUsers?.find((user) => user?.value === selectedFoundCaseManager)?.label;
      const newCaseManager = foundItemCaseManagerUsers?.find((user) => user?.value === updateCaseMangerId)?.label;
      return updateCaseMangerId !== unAssignCaseMangerOptionValue && currentCaseManager ? `Are you sure to unassign ${currentCaseManager} and assign to ${newCaseManager} for this report?` : updateCaseMangerId === unAssignCaseMangerOptionValue && currentCaseManager ? `Are you sure to unassign ${currentCaseManager}?` : updateCaseMangerId && !selectedFoundCaseManager ? `Are you sure to assign ${newCaseManager} for this report?` : "";
    }
    return "";
  }, [selectedCaseManager, updateCaseManger, caseManagerUsers, foundItemCaseManagerUsers, selectedFoundCaseManager]);

  const confirmUpdateCaseManagerTitle = useMemo(() => {
    if (caseManagerUsers?.length > 0 || foundItemCaseManagerUsers?.length > 0) {
      return updateCaseManger?.id === unAssignCaseMangerOptionValue ? "Confirm Unassigning?" : "Confirm Assigning?";
    }
    return "";
  }, [selectedCaseManager, updateCaseManger, caseManagerUsers, foundItemCaseManagerUsers]);


  useEffect(() => {
    if (shippingOptions && shippingOptions?.length > 0) {
      const mappedData = shippingOptions.reduce((acc, item, index) => {
        acc[`option${index + 1}`] = {
          id: item?.id ?? "",
          shipFrom: item.shipFrom?.id ?? "",
          port: item.port ?? "",
          comment: item.comment ?? "",
          cutOffDate: item?.cutOffDate ? dayjs(item?.cutOffDate) : null,
          shipFromPort: item.shipFrom?.id ?? "",
          contactName: item.contactName ?? "",
          country: item.country?.toString() ?? "",
          state: item.state?.toString() ?? "",
          address1: item.address1 ?? "",
          address2: item.address2 ?? "",
          city: item.city?.toString() ?? "",
          zip: item.zip ?? "",
          email: item.email ?? "",
          phone: item.phone ?? "",
          description: item.description ?? "",
          isSelected: item.isSelected || false,
        };
        return acc;
      }, {} as Record<string, any>);
      step2Form.setFieldsValue(mappedData);
      setStep2Data(mappedData);
    }
  }, [shippingOptions, dispatch]);

  const handleUpdateCaseManager = async (value: any) => {
    if (report?.id) {
      setLoading(true);
      const isUnAssigned = value === unAssignCaseMangerOptionValue;
      try {
        await dispatch(
          updateCaseManger?.type === ReportType.Found ? updateFoundItemCaseManager({
            id: selectedItemDetails?.id?.toString() ?? "",
            caseManager: isUnAssigned ? null : value,
          }) : updateLostItemCaseManager({
            id: report?.id?.toString(),
            caseManager: isUnAssigned ? null : value,
          })
        ).unwrap();
        const oldCaseManagerName = report?.caseManager?.id ? caseManagers?.find((user) => user?.id === report?.caseManager?.id)?.firstName + " " + caseManagers?.find((user) => user?.id === report?.caseManager?.id)?.lastName : "";
        const newCaseManagerName = isUnAssigned ? "" : caseManagers?.find((user) => user?.id === value)?.firstName + " " + caseManagers?.find((user) => user?.id === value)?.lastName;
        const newCaseManagerFirstName = isUnAssigned ? "" : caseManagers?.find((user) => user?.id === value)?.firstName;
        const newCaseManger = isUnAssigned ? undefined : caseManagers?.find((user) => user?.id === value);
        message.success({
          content: (
            <>
              {isUnAssigned ? <>
                Case Manager {oldCaseManagerName} unassigned
              </> : oldCaseManagerName ? (
                <>
                  Case Manager changed from {oldCaseManagerName} to <strong>{newCaseManagerName}</strong>
                </>
              ) : (
                <>
                  Report assigned to <strong>{newCaseManagerName}</strong>
                </>
              )}
            </>
          ),
        });
        await dispatch(updateTicketLocally({ ticket: convertIntoBoardTicket({ ...report, caseManagerName: newCaseManagerFirstName, caseManager: newCaseManger }) }));
        await updateCaseManger?.type === ReportType.Found ? dispatch(updateItemCaseManager({ caseManager: newCaseManger })) : dispatch(updateCaseManager({ caseManager: newCaseManger }));

        updateCaseManger?.type === ReportType.Found && selectedItemDetails && setSelectedItemDetails({ ...selectedItemDetails, caseManagerName: newCaseManagerFirstName, caseManager: newCaseManger })
        updateCaseManger?.type === ReportType.Lost ? setSelectedCaseManager(isUnAssigned ? "" : value) : setSelectedCaseFoundManager(isUnAssigned ? "" : value);
        setUpdateCaseManger(null)
      } catch (error) {
        console.log({ error });
      } finally {
        setLoading(false);
      }
    }
  };

  const columns = [
    {
      title: "Criteria",
      dataIndex: "criteria",
      key: "criteria",
    },
    {
      title: "Lost Item",
      dataIndex: "lostItem",
      key: "lostItem",
    },
    {
      title: "Found Item",
      dataIndex: "foundItem",
      key: "foundItem",
    },
  ];

  useEffect(() => {
    if (selectedItem) {
      getSelectedItemDetails(selectedItem);
    }
  }, [selectedItem]);

  useEffect(() => {
    if (report?.id) {
      dispatch(getAllShippingOptions({ lostId: report?.id }));
    }
  }, [report?.id]);

  useEffect(() => {
    if (ShipFromPortStatus === RequestResults.idle && !ShipFromPorts?.length && !isFinalMatch) {
      dispatch(fetchShipFromPorts({ status: ActivationStatus.Active }));
    }
  }, [ShipFromPortStatus, ShipFromPorts, isFinalMatch]);

  const onClose = () => {
    if (!isFinalMatch) {
      handleItemClick(null);
    }
    handleMarkCancel();
  };

  const carouselSettings = {
    dots: false,
    arrows: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1740,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 1540,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 1440,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 1300,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 1130,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2.7,
        },
      },
      {
        breakpoint: 880,
        settings: {
          slidesToShow: 2.4,
        },
      },
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 2.1,
        },
      },
      {
        breakpoint: 700,
        settings: {
          slidesToShow: 1.8,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 425,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  // Use selectedItem data to populate the comparison
  const lostAndFoundData = {
    lostItem: {
      id: report?.id,
      category: report?.category?.name || "",
      subCategory: report?.subCategory?.name || "",
      questions: report?.subCategory?.questions?.flatMap((q: Question) => {
        switch (q.fieldType) {
          case 1:
            return [{
              fieldName: q.fieldName,
              answer: (q.answers?.answer) === "true" ? "Yes" : q.answers?.answer ===
                "false" ? "No" : q.answers?.answer || "N/A",
            }];
          case 2:
            const selectedOption2 = q.options?.find((option: any) => option.name === q.answers?.answer);
            const subQuestions2 = selectedOption2?.subQuestion?.map((subQ: any) => ({
              fieldName: subQ.fieldName,
              answer: subQ.answers?.answer || "N/A",
            })) || [];
            return [{
              fieldName: q.fieldName,
              answer: q.answers?.answer || "N/A",
            }, ...subQuestions2];
          case 3:
            const selectedOption3 = q.options?.find((option: any) => option.name === q.answers?.answer);
            const subQuestions3 = selectedOption3?.subQuestion?.map((subQ: any) => ({
              fieldName: subQ.fieldName,
              answer: subQ.answers?.answer || "N/A",
            })) || [];
            return [{
              fieldName: q.fieldName,
              answer: q.answers?.answer || "N/A",
            }, ...subQuestions3];
          default:
            return [];
        }
      }) || [],
      description: report?.itemDescription || "",
      remarks: report?.whereDescription || report?.documentDescription || "",
      whereDescription: report?.whereDescription || "",
      images: report?.documents?.map((doc: any) => doc.fullUrl) || null,
      airport: report?.airport?.name || "",
      location: report?.location?.name || "",
      locationQuestions:
        report?.location?.questions?.map((q: any) => ({
          fieldName: q.fieldName,
          answer: q.answers?.answer || "",
        })) || [],
      lostandFoundDate: report?.lostDate ? convertUtcToLocal(report?.lostDate, "MM/DD/YYYY") : "",
      caseManager: report?.caseManager || null,
    },
    foundItem: selectedItemDetails
      ? {
        id: selectedItemDetails?.id,
        category: selectedItemDetails?.category?.name || "",
        subCategory: selectedItemDetails?.subCategory?.name || "",
        questions: selectedItemDetails?.subCategory?.questions?.flatMap((q: Question) => {
          switch (q.fieldType) {
            case 1:
              return [{
                fieldName: q.fieldName,
                answer: q.answers?.answer === "true" ? "Yes" : q.answers?.answer === "false" ? "No" : q.answers?.answer || "N/A",
              }];
            case 2:
              const selectedOption2 = q.options?.find((option: any) => option.name === q.answers?.answer);
              const subQuestions2 = selectedOption2?.subQuestion?.map((subQ: any) => ({
                fieldName: subQ.fieldName,
                answer: subQ.answers?.answer || "N/A",
              })) || [];
              return [{
                fieldName: q.fieldName,
                answer: q.answers?.answer || "N/A",
              }, ...subQuestions2];
            case 3:
              const selectedOption3 = q.options?.find((option: any) => option.name === q.answers?.answer);
              const subQuestions3 = selectedOption3?.subQuestion?.map((subQ: any) => ({
                fieldName: subQ.fieldName,
                answer: subQ.answers?.answer || "N/A",
              })) || [];
              return [{
                fieldName: q.fieldName,
                answer: q.answers?.answer || "N/A",
              }, ...subQuestions3];
            default:
              return [];
          }
        }) || [],
        description: selectedItemDetails?.itemDescription || "",
        remarks: selectedItemDetails?.remarks || "",
        images: selectedItemDetails?.documents?.map((doc: any) => doc.fullUrl) || null,
        airport: selectedItemDetails?.airport?.name || "",
        location: selectedItemDetails?.location?.name || "",
        locationQuestions:
          selectedItemDetails?.location?.questions?.map((q: any) => ({
            fieldName: q.fieldName,
            answer: q.answers?.answer || "",
          })) || [],
        lostandFoundDate: selectedItemDetails?.foundDate ? convertUtcToLocal(selectedItemDetails?.foundDate, "MM/DD/YYYY") : "",
        caseManager: selectedItemDetails?.caseManager || null,
      }
      : {},
  };


  const renderFoundItemValue = (value: string | undefined) => {
    if (selectedItemDetailsStatus === "loading") {
      return <Skeleton.Input active size="small" style={{ width: "150px", height: "20px" }} />;
    }
    return value || "-";
  };

  const renderSelectCaseManger = (selectedCaseManager: AdminUser | null | undefined, type: ReportType) => {
    if (selectedItemDetailsStatus === "loading") {
      return <Skeleton.Input active size="small" style={{ width: "150px", height: "20px" }} />;
    }
    if (isFinalMatch) {
      return selectedCaseManager?.id ? selectedCaseManager?.firstName + " " + selectedCaseManager?.lastName : "";
    }
    return (
      <Select style={{ width: "90%" }} placeholder="Select Case Manager" disabled={report?.status === FoundStatuses.FinalMatch} value={selectedCaseManager?.id || ""} options={type === ReportType.Found ? foundItemCaseManagerUsers : caseManagerUsers} loading={loading || caseManagerStatus === RequestResults.pending} onSelect={(value: any) => setUpdateCaseManger({ id: value, type })} />
    );
  }

  const hasLocationQuestions = useMemo(() => report?.location?.questions && report?.location?.questions?.length > 0, [report]);

  const tableData = useMemo(() => {
    const questionData = lostAndFoundData.lostItem.questions.map((question, index) => {
      const foundQuestion = lostAndFoundData.foundItem.questions?.find((q) => q.fieldName === question.fieldName);
      return {
        key: `question-${index}`,
        criteria: question.fieldName,
        lostItem: question.answer || "-",
        foundItem: renderFoundItemValue(foundQuestion?.answer),
      };
    });


    return [
      {
        key: "1",
        criteria: "Category",
        lostItem: lostAndFoundData.lostItem.category || "-",
        foundItem: renderFoundItemValue(lostAndFoundData.foundItem.category),
      },
      {
        key: "2",
        criteria: "Sub-Category",
        lostItem: lostAndFoundData.lostItem.subCategory || "-",
        foundItem: renderFoundItemValue(lostAndFoundData.foundItem.subCategory),
      },
      ...questionData,
      {
        key: "6",
        criteria: "Item Description",
        lostItem: lostAndFoundData.lostItem.description || "-",
        foundItem: renderFoundItemValue(lostAndFoundData.foundItem.description),
      },
      {
        key: "7",
        criteria: "Remarks",
        lostItem: lostAndFoundData.lostItem.remarks || "-",
        foundItem: renderFoundItemValue(lostAndFoundData.foundItem.remarks),
      },
      {
        key: "8",
        criteria: "Images",
        lostItem: (
          <ImageContainer isActive={Boolean(lostAndFoundData.lostItem.images && lostAndFoundData.lostItem.images?.length > 0)}>
            {lostAndFoundData.lostItem.images && lostAndFoundData.lostItem.images?.length > 0 ? (
              <PreMatchImageWrapper>
                {lostAndFoundData.lostItem.images.map((image: string) => (
                  <Image src={image} alt="Lost item" />
                ))}
              </PreMatchImageWrapper>
            ) : (
              <PreMatchImageWrapper>No images uploaded</PreMatchImageWrapper>
            )}
          </ImageContainer>
        ),
        foundItem: (
          <ImageContainer isActive={Boolean(lostAndFoundData.foundItem.images && lostAndFoundData.foundItem.images?.length > 0)}>
            {selectedItemDetailsStatus === "loading" ? (
              <Skeleton.Image active style={{ width: "92px", height: "92px" }} />
            ) : lostAndFoundData.foundItem.images && lostAndFoundData.foundItem.images?.length > 0 ? (
              <PreMatchImageWrapper>
                {lostAndFoundData.foundItem.images?.map((image: string) => (
                  <Image src={image} alt="Found item" />
                ))}
              </PreMatchImageWrapper>
            ) : (
              <PreMatchImageWrapper>No images uploaded</PreMatchImageWrapper>
            )}
          </ImageContainer>
        ),
      },
      {
        key: "9",
        criteria: "Location",
        lostItem: lostAndFoundData.lostItem.location || "-",
        foundItem: lostAndFoundData.foundItem.location || "-",
      },
      ...(hasLocationQuestions
        ? [
          {
            key: "10",
            criteria: `${lostAndFoundData.lostItem.locationQuestions?.length > 0 && lostAndFoundData.lostItem.locationQuestions?.map((q: any) => q.fieldName)}`,
            lostItem: lostAndFoundData.lostItem.locationQuestions?.length ? lostAndFoundData.lostItem.locationQuestions.map((q: any) => <div key={q.fieldName}>{q.answer}</div>) : "-",
            foundItem: lostAndFoundData.foundItem.locationQuestions?.length ? lostAndFoundData.foundItem.locationQuestions.map((q: any) => <div key={q.fieldName}>{q.answer}</div>) : "-",
          },
        ]
        : []),
      {
        key: "11",
        criteria: "Airport Name",
        lostItem: lostAndFoundData.lostItem.airport || "-",
        foundItem: lostAndFoundData.foundItem.airport || "-",
      },
      {
        key: "12",
        criteria: "Lost/Found Date",
        lostItem: lostAndFoundData.lostItem.lostandFoundDate || "-",
        foundItem: lostAndFoundData.foundItem.lostandFoundDate || "-",
      },
      {
        key: "13",
        criteria: "Case Manager",
        lostItem: renderSelectCaseManger(lostAndFoundData?.lostItem?.caseManager, ReportType.Lost) || "-",
        foundItem: renderSelectCaseManger(lostAndFoundData?.foundItem?.caseManager, ReportType.Found) || "-",
      },

    ];
  }, [lostAndFoundData, hasLocationQuestions]);

  const handleFormSubmit = async () => {
    if (report?.id) {
      setLoading(true);
      try {
        const linkPayload = {
          lostId: lostAndFoundData?.lostItem?.id ?? "",
          foundId: lostAndFoundData?.foundItem?.id ?? "",
        };

        if (!linkPayload?.lostId || !linkPayload?.foundId) return;

        const sourceStatus = report?.status;

        // If not final match, create prematch data
        if (!isFinalMatch) {
          const step3Data = step3Form.getFieldsValue();
          const createdShippingOptions = Object.keys(step2Data).map((key) => {
            const { shipFromPort, ...rest } = step2Data[key]; // remove shipFromPort
            return {
              ...rest,
              shipFrom: rest.shipFrom ? rest.shipFrom : null,
              cutOffDate: enableCutOffDate ? rest?.cutOffDate?.toISOString() : null,
              lost: lostAndFoundData.lostItem.id,
              // isInsuranceAllowed: true,
            };
          });
          const deletedShippingOptions = shippingOptions?.filter((option) => !createdShippingOptions.some((createdOption) => createdOption.id === option.id))?.map((option) => option.id.toString()) || [];
          const deletedOptions: string[] = deletedShippingOptions;
          const requestBody = {
            shippingOptions: createdShippingOptions,
            package: {
              ...convertToApiFormat(step3Data, step3Data.measurementType),
              lost: linkPayload.lostId,
              found: linkPayload.foundId,
              description: step3Data.description,
            },
            deletedOptions,
          };

          await dispatch(createPrematchData(requestBody)).unwrap();
        }

        // Continue with the existing logic for updating lost item status
        const response = await dispatch(linkFoundItemWithLostItemAsyncThunk(linkPayload));
        if (response?.payload) {
          await dispatch(
            updateLostItemStatus({
              id: report?.id?.toString(),
              status: 0,
            })
          ).unwrap();
          await dispatch(
            updateFoundItemStatus({
              id: linkPayload.foundId?.toString(),
              status: FoundStatuses.Prematched,
            })
          ).unwrap();
          await dispatch(updateTicketStatusLocally({ ticket: convertIntoBoardTicket(report), sourceStatus, targetStatus: 0 }));
          await dispatch(removeTicketById({ id: linkPayload?.foundId?.toString() }));
          report?.trackingId && (await fetchReport(report?.trackingId.toString()));
          onClose();
        }
      } catch (error) {
        console.log({ error });
      } finally {
        setLoading(false);
      }
    }
  };

  const handleNext = async () => {
    if (step === 2 || step === 3) {
      try {
        // Get the form instance based on current step
        const currentForm = step === 2 ? step2Form : step3Form;
        const values = await currentForm.validateFields();
        const formateValues = { ...values };
        if (formateValues?.option1?.searchAddress) {
          delete formateValues?.option1?.searchAddress;
        }
        // Store form values when step 2 is completed
        if (step === 2) {
          setStep2Data(formateValues);
        } else if (step === 3) {
          await handleFormSubmit();
        }
      } catch (error) {
        // Validation failed, don't proceed
        return;
      }
    }

    if (step < 3) {
      setStep(step + 1);
    }
  };

  const handleBack = () => {
    if (step > 1) {
      setStep(step - 1);
    }
  };

  const handleFinalMatch = async () => {
    try {
      // Get selected shipping option IDs
      const selectedShippingOptionIds = shippingOptions
        ?.filter((option: any) => option.isSelected)
        ?.map((option: any) => option.id.toString()) || [];

      const requestPayload = {
        lost: lostAndFoundData?.lostItem?.id ?? "",
        found: lostAndFoundData?.foundItem?.id ?? "",
        selected: selectedShippingOptionIds
      }

      await dispatch(sendPaymentRequest(requestPayload)).unwrap();
      toast.success("Item match and payment request sent successfully");
      onClose();
    } catch (error) {
      console.log({ error });
    }
  }

  const renderStepContent = useCallback(() => {
    if (isFinalMatch) {
      return (
        <>
          <Step1
            loading={loading}
            carouselSettings={carouselSettings}
            preMatchedFoundItems={preMatchedFoundItems ?? []}
            handleItemClick={handleItemClick}
            selectedItem={selectedItem}
            columns={columns}
            tableData={tableData}
            isFinalMatch={isFinalMatch}
          />
          <DimensionsTable />
        </>
      );
    }
    switch (step) {
      case 1:
        return (
          <Step1
            loading={loading}
            carouselSettings={carouselSettings}
            preMatchedFoundItems={preMatchedFoundItems ?? []}
            handleItemClick={handleItemClick}
            selectedItem={selectedItem}
            columns={columns}
            tableData={tableData}
            isFinalMatch={isFinalMatch}
            isModal={true}
          />
        );
      case 2:
        return <Step2 form={step2Form} data={step2Data} />;
      case 3:
        return <Step3 form={step3Form} />;
      default:
        return null;
    }
  }, [step, loading, carouselSettings, preMatchedFoundItems, handleItemClick, selectedItem, columns, tableData, isFinalMatch]);

  const disabledFinalMatchBtn = useMemo(() => {
    // Check if there's at least one selected shipping option with valid data
    const hasValidSelectedOption = shippingOptions?.some(
      option => option.isSelected && option?.totalAmount && option?.courier?.id
    );

    return loading || !hasValidSelectedOption;
  }, [shippingOptions, loading])

  const renderFooterButtons = () => {
    if (isFinalMatch) {
      return (
        <FooterButtonsContainer>
          <LeftButtons></LeftButtons>
          <RightButtons>
            <StyledButton onClick={onClose} disabled={loading}>
              Cancel
            </StyledButton>
            {isFinalMatchPermission && <StyledButton type="primary" onClick={() => handleFinalMatch()} loading={loading || paymentRequestLoading} disabled={disabledFinalMatchBtn}>
              Final Match
            </StyledButton>}
          </RightButtons>
        </FooterButtonsContainer>
      );
    }
    if (step === 3) {
      return (
        <FooterButtonsContainer>
          <LeftButtons>
            <StyledButton onClick={handleBack} disabled={loading}>
              Back
            </StyledButton>
          </LeftButtons>
          <RightButtons>
            <StyledButton type="primary" onClick={handleNext} loading={loading} disabled={loading}>
              Pre-Match
            </StyledButton>
          </RightButtons>
        </FooterButtonsContainer>
      );
    }

    return (
      <FooterButtonsContainer>
        <LeftButtons>
          {step > 1 && (
            <StyledButton onClick={handleBack} disabled={loading}>
              Back
            </StyledButton>
          )}
        </LeftButtons>
        <RightButtons>
          <StyledButton onClick={onClose} disabled={loading}>
            Cancel
          </StyledButton>
          <StyledButton type="primary" onClick={handleNext} disabled={loading}>
            Next
          </StyledButton>
        </RightButtons>

      </FooterButtonsContainer>
    );
  };

  return (
    <StyledModal
      draggable={true}
      width={1300}
      maxHeight={`calc(100dvh - 200px)`}
      title={
        isFinalMatch ? (
          <TitleContent>Final Match</TitleContent>
        ) : (
          <TitleWrapper>
            <TitleContent>
              {step > 1 && <BackArrow onClick={handleBack} />}
              {step === 1 ? <span>Select best match</span> : step === 2 ? <span>Ship from info</span> : <span>Package Info</span>}
            </TitleContent>
            <StepText>Step ({step}/3)</StepText>
          </TitleWrapper>
        )
      }
      centered
      open={isMarkModalOpen}
      onCancel={onClose}
      footer={renderFooterButtons()}
    >
      <ModalContent><>{renderStepContent()}
        {updateCaseManger?.id && <ConfirmationModal isModalOpen={updateCaseManger ? true : false} onCancel={() => setUpdateCaseManger(null)} message={confirmUpdateCaseManager} title={confirmUpdateCaseManagerTitle} loading={loading} handleSave={() => handleUpdateCaseManager(updateCaseManger?.id)} CancelButtonText="Cancel" confirmButtonText={updateCaseManger?.id === unAssignCaseMangerOptionValue ? "Unassign" : "Assign"} />}
      </>
      </ModalContent>
    </StyledModal>
  );
};

export default PrematchModal;
